<template>
  <transition
    enter-active-class="transition duration-200 ease-out"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition duration-150 ease-in"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="show"
      class="fixed inset-0 z-[1200] flex flex-col bg-black/15 backdrop-blur-xs"
      @keydown.esc.prevent="close"
      tabindex="0"
      ref="overlay"
    >
      <div class="mx-2 my-2 flex min-h-0 flex-1 flex-col overflow-hidden bg-gray-50  sm:m-4">
        <header class="flex items-center justify-between px-4 py-3">
          <div>
            <h3 class="text-sm font-semibold tracking-wide text-gray-900">Input resource view</h3>
          </div>
          <button
            type="button"
            class="inline-flex h-9 w-9 items-center justify-center rounded-md border border-gray-300 text-gray-700 transition hover:bg-gray-100 hover:text-black"
            @click="close"
            aria-label="Close resource timeline"
          >
            <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </header>

        <div class="min-h-0 flex-1">
          <bly-resource-view-timeline
            class="h-full"
            :dataset="dataset"
            :range="range"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ResourceViewTimelineFullscreen',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    dataset: {
      type: Array,
      default: () => [],
    },
    range: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(value) {
        if (value) {
          this.lockScroll();
          this.$nextTick(() => {
            if (this.$refs.overlay) this.$refs.overlay.focus();
          });
        } else {
          this.unlockScroll();
        }
      },
    },
  },
  beforeDestroy() {
    this.unlockScroll();
  },
  methods: {
    close() {
      this.$emit('update:show', false);
    },
    lockScroll() {
      document.body.style.overflow = 'hidden';
    },
    unlockScroll() {
      document.body.style.overflow = '';
    },
  },
};
</script>
